import React from 'react';
import { isArrayLength } from '../../../util/genericHelpers';
import classNames from 'classnames';
import { Icons, NamedLink, PrimaryButton } from '../../../components';

import css from './Sections.module.css';

function SectionTalentPlus({ talentPlusMaybe }) {
  return (
    <>
      {isArrayLength(talentPlusMaybe)
        ? talentPlusMaybe.map((t, index) => (
            <div key={index} className={css.getCustomVideo}>
              {index === 0 ? <h2>Talent plus services</h2> : null}
              <div className={css.videoPrice}>
                {t?.type ? (
                  <div className={css.detailBlock}>
                    <span>Type</span>
                    <p>{t?.type}</p>
                  </div>
                ) : null}
                {t?.service ? (
                  <div className={css.detailBlock}>
                    <span>Service</span>
                    <p>{t?.service}</p>
                  </div>
                ) : null}
                {t?.price ? (
                  <div className={css.detailBlock}>
                    <span>Price</span>
                    <p>${Number(t?.price).toFixed(2)}</p>
                  </div>
                ) : null}
              </div>
            </div>
          ))
        : null}
      <div className={css.bookingSec}>
        <div className={classNames(css.offerSec, css.withoutIconSec)}>
          <div className={css.offerContent}>
            <p>
              Buy the service today and enjoy exclusive benefits.
              <NamedLink name="TermsOfServicePage">Terms apply</NamedLink>{' '}
            </p>

            <PrimaryButton className={css.bookBtn}>
              <Icons name="security" />
              Buy now
            </PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionTalentPlus;
